import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const inventoryApi = createApi({
  reducerPath: 'inventoryApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Inventory'],
  endpoints: (builder) => ({
    getMaterials: builder.query<unknown[], void>({
      query: () => 'inventory/materials',
      providesTags: ['Inventory'],
    }),
    getSuppliers: builder.query<unknown[], void>({
      query: () => 'inventory/suppliers',
      providesTags: ['Inventory'],
    }),
    importMaterials: builder.mutation<unknown, FormData>({
      query: (body) => ({
        url: 'inventory/materials/import',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Inventory'],
    }),
  }),
});

export const {
  useGetMaterialsQuery,
  useGetSuppliersQuery,
  useImportMaterialsMutation,
} = inventoryApi;
